// extracted by mini-css-extract-plugin
module.exports = {"custom_table":"CustomTable_custom_table__3fqLC","nodata":"CustomTable_nodata__RtUb7"};